import type { EventFace } from "../types";
import { eventLabels } from "../gameMeta";
import { OfficialArtwork } from "./OfficialArtwork";

export function EventFaceIcon({ event, className = "" }: { event: EventFace; className?: string }) {
  return (
    <span
      className={`event-face-icon event-face-${event} ${className}`.trim()}
      data-event-face={event}
      role="img"
      aria-label={`Gebeurtenissymbool: ${eventLabels[event]}`}
    >
      <EventFaceFallback event={event} />
      <OfficialArtwork assetKey={`events/${event}`} className="official-event-face-art" />
    </span>
  );
}

function EventFaceFallback({ event }: { event: EventFace }) {
  return (
    <svg className="event-face-fallback" viewBox="0 0 64 64" aria-hidden="true">
      {event === "roofoverval" ? (
        <>
          <path d="M18 49c7-11 13-22 18-34 2-5 8-4 11-1 3 4 1 9-3 11-11 6-16 16-20 28Z" fill="currentColor" />
          <path d="M20 47 45 20" fill="none" stroke="#fff" strokeOpacity=".45" strokeWidth="2" />
        </>
      ) : event === "handel" ? (
        <>
          <path d="M32 12v38M18 18h28M24 18 14 39M40 18l10 21M8 39h12c0 6-12 6-12 0Zm36 0h12c0 6-12 6-12 0ZM22 51h20" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="4" />
        </>
      ) : event === "feest" ? (
        <>
          <path d="M21 52c11-5 17-17 17-38 10 4 15 12 12 22-4 13-14 19-29 16Z" fill="none" stroke="currentColor" strokeLinejoin="round" strokeWidth="5" />
          <path d="M28 46 43 23M33 49 47 31M20 52h13" fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="2.5" />
        </>
      ) : event === "goede_oogst" ? (
        <>
          <path d="M19 53c9-10 16-23 24-42" fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="4" />
          <path d="M25 43c-9 0-12-5-12-11 8-1 13 3 12 11Zm6-10c-8-2-10-8-8-14 8 1 11 7 8 14Zm5-10c-6-3-7-9-4-14 7 3 8 8 4 14Zm-6 20c2-8 8-11 14-9-1 8-6 11-14 9Zm6-12c3-7 9-9 14-6-2 7-7 9-14 6Z" fill="currentColor" />
        </>
      ) : (
        <text x="32" y="49" textAnchor="middle" fontFamily="Georgia, serif" fontSize="52" fontWeight="900" fill="currentColor">?</text>
      )}
    </svg>
  );
}
